module.exports = __webpack_public_path__ + "img/7-ruby.8c5cc36d.png";